import React from 'react'
import { Box, Paper, Skeleton } from '@mui/material'

const PriceSummary = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'borders.default',
                p: 2,
                mb: 2
            }}
        >
            {/* Price Summary Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Skeleton variant="text" width={100} height={20} />
                <Skeleton variant="text" width={80} height={16} />
            </Box>

            {/* Price Items */}
            {[...Array(2)].map((_, index) => (
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                    <Skeleton variant="text" width={120} height={16} />
                    <Skeleton variant="text" width={60} height={16} />
                </Box>
            ))}

            {/* Total */}
            <Box sx={{ borderTop: '1px solid', borderColor: 'borders.default', pt: 1, mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Skeleton variant="text" width={80} height={20} />
                    <Skeleton variant="text" width={80} height={24} />
                </Box>
            </Box>
        </Paper>
    )
}

export default PriceSummary
